import api from './app-controller'
import ITEM_ENDPOINTS from "../routes/item-routes";

export const getItem = async (itemId) => await api.get(`${ITEM_ENDPOINTS.GET_ITEM(itemId)}`);
export const getItems = async () => await api.get(ITEM_ENDPOINTS.GET_ITEMS);
export const getItemsByLimit = async (limit) => await api.get(ITEM_ENDPOINTS.GET_ITEMS_BY_LIMIT(limit));
export const getItemsByCategory = async (categoryId, page) => await api.get(ITEM_ENDPOINTS.GET_ITEMS_BY_CATEGORY(categoryId, page));
export const getItemsByPagination = async (page) => await api.get(ITEM_ENDPOINTS.GET_ITEMS_BY_PAGINATION(page));